import React from 'react';

export default function NoteWithLinks({ html }: { html: string }) {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  function renderNode(node: Node): React.ReactNode {
    if (node.nodeType === Node.TEXT_NODE) return node.textContent;

    if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node as Element;
      const children = Array.from(el.childNodes).map((c, i) => (
        <React.Fragment key={i}>{renderNode(c)}</React.Fragment>
      ));

      if (el.tagName === 'A') {
        const href = el.getAttribute('href') ?? '';
        const safeHref = /^https?:\/\//i.test(href) ? href : '';
        return (
          <a
            href={safeHref}
            target='_blank'
            rel='noopener noreferrer'
            style={{ color: 'inherit', fontSize: 'inherit' }}
          >
            {children}
          </a>
        );
      }

      return children;
    }

    return null;
  }
  return (
    <>
      {Array.from(doc.body.childNodes).map((node, i) => (
        <React.Fragment key={i}>{renderNode(node)}</React.Fragment>
      ))}
    </>
  );
}
